const ID_WHITELIST = new Set(["referenceId"]);

export const removeIdKeysFromData = (data: any) => {
  if (data === null || data === undefined) {
    return [];
  }
  return data.map((object: any) =>
    Object.fromEntries(
      Object.entries(object).filter(([key]) => {
        if (ID_WHITELIST.has(key)) return true;
        return !/Id$/i.test(key);
      })
    )
  );
};
